import { Modal } from 'components/modal/modal'
import React, { ChangeEvent, useState } from 'react'
import { Button } from 'ui-kit/button'

import { ButtonContainer, Description, FeedbackTextarea, ModalContainer, Title } from './FeedbackModal.styles'

interface FeedbackModalProps {
  isOpen: boolean
  onSubmit: (feedback: string) => void
}

export const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onSubmit }) => {
  const [feedback, setFeedback] = useState('')

  const handleSubmit = () => {
    onSubmit(feedback)
  }

  const handleFeedbackChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setFeedback(e.target.value)
  }

  return (
    <Modal isOpen={isOpen} center fluid>
      <ModalContainer>
        <Title>Help Us Improve</Title>
        <Description>
          We&apos;re sorry to see you go! Would you mind sharing why you&apos;re canceling your subscription? Your
          feedback helps us improve our service for everyone.
        </Description>
        <FeedbackTextarea
          required
          value={feedback}
          onChange={handleFeedbackChange}
          placeholder="Tell us why you're canceling..."
          rows={4}
        />
        <ButtonContainer>
          <Button variant="primary" onClick={handleSubmit}>
            Submit Feedback
          </Button>
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  )
}
